module.exports = __webpack_public_path__ + "static/media/holiday-script.60ead2e3.svg";